import { createVideoSlot } from '../../utils/utils';


const VpaidVideoPlayer = function () {
  this.slot_ = null;
  this.videoSlot_ = null;
  this.eventsCallbacks_ = {};
  this.attributes_ = {
    'companions': '',
    'desiredBitrate': 256,
    'duration': 30,
    'expanded': false,
    'height': 0,
    'icons': '',
    'linear': true,
    'remainingTime': 10,
    'skippableState': false,
    'viewMode': 'normal',
    'width': 0,
    'volume': 0.0
  };

  this.quartileEvents_ = [
    { event: 'AdVideoStart', value: 0 },
    { event: 'AdImpression', value: 3 },
    { event: 'AdVideoFirstQuartile', value: 25 },
    { event: 'AdVideoMidpoint', value: 50 },
    { event: 'AdVideoThirdQuartile', value: 75 },
    { event: 'AdVideoComplete', value: 100 }
  ];
  this.lastQuartileIndex_ = 0;
  this.parameters_ = {
    debug: false,
  };
};

VpaidVideoPlayer.prototype.initAd = function (
  width,
  height,
  viewMode,
  desiredBitrate,
  creativeData,
  environmentVars) {
  this.attributes_['width'] = width;
  this.attributes_['height'] = height;
  this.attributes_['viewMode'] = viewMode;
  this.attributes_['desiredBitrate'] = desiredBitrate;
  this.slot_ = environmentVars.slot;
  this.videoSlot_ = environmentVars.videoSlot;

  this.parameters_ = JSON.parse(creativeData['AdParameters']);

  this.log('initAd ' + width + 'x' + height +
    ' ' + viewMode + ' ' + desiredBitrate);
  this.updateVideoSlot_();
  this.videoSlot_.addEventListener(
    'loadeddata',
    this.dataLoadHandler_.bind(this),
    false);
  // this.videoSlot_.addEventListener(
  //   'timeupdate',
  //   this.timeUpdateHandler_.bind(this),
  //   false);
  this.videoSlot_.addEventListener(
    'ended',
    this.stopAd.bind(this),
    false);

  console.log('AdLoaded VAST');
  this.callEvent_('AdLoaded');
};

VpaidVideoPlayer.prototype.overlayOnClick_ = function () {
  this.callEvent_('AdClickThru');

  if (this.parameters_.overlay) {
    window.open(this.parameters_.overlay);
  }
};

VpaidVideoPlayer.prototype.dataLoadHandler_ = function () {
  this.attributes_['duration'] = this.videoSlot_.duration;
}

VpaidVideoPlayer.prototype.timeUpdateHandler_ = function () {
  if (this.lastQuartileIndex_ >= this.quartileEvents_.length) {
    return;
  }
  this.attributes_['remainingTime'] = this.videoSlot_.duration - this.videoSlot_.currentTime;
  var percentPlayed =
    this.videoSlot_.currentTime * 100.0 / this.videoSlot_.duration;
  if (percentPlayed >= this.quartileEvents_[this.lastQuartileIndex_].value) {
    var lastQuartileEvent = this.quartileEvents_[this.lastQuartileIndex_].event;
    this.eventsCallbacks_[lastQuartileEvent]();
    this.lastQuartileIndex_ += 1;
  }
};

VpaidVideoPlayer.prototype.updateVideoSlot_ = function () {
  if (this.videoSlot_ == null) {
    this.videoSlot_ = createVideoSlot();
    this.log('Warning: No video element passed to ad, creating element.');
    this.slot_.appendChild(this.videoSlot_);
  }
  this.updateVideoPlayerSize_();
  var foundSource = false;
  var videos = this.parameters_.videos || [];
  for (var i = 0; i < videos.length; i++) {
    if (this.videoSlot_.canPlayType(videos[i].mimetype) != '') {
      const sourceElement = document.createElement('source');
      sourceElement.setAttribute('src', videos[i].url);
      sourceElement.setAttribute('type', videos[i].mimetype);
      this.videoSlot_.appendChild(sourceElement);

      foundSource = true;
    }
  }
  if (!foundSource) {
    this.callEvent_('AdError');
  }
};

VpaidVideoPlayer.prototype.updateVideoPlayerSize_ = function () {
  this.videoSlot_.setAttribute('width', this.attributes_['width']);
  this.videoSlot_.setAttribute('height', this.attributes_['height']);
};

VpaidVideoPlayer.prototype.handshakeVersion = function (version) {
  return ('2.0');
};

VpaidVideoPlayer.prototype.startAd = function () {
  this.log('Starting ad');
  this.videoSlot_.addEventListener(
    'timeupdate',
    this.timeUpdateHandler_.bind(this),
    false);

  this.videoSlot_.play();
  // var clickthru = document.createElement('div');
  // clickthru.style.cssText = 'position: absolute; left: 0; top: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer;';
  // this.slot_.appendChild(clickthru);
  this.slot_.addEventListener('click', this.overlayOnClick_.bind(this), false);

  this.callEvent_('AdStarted');
};

VpaidVideoPlayer.prototype.stopAd = function () {
  
  this.log('Stopping ad');
  this.videoSlot_.pause();
  this.videoSlot_.currentTime = 0;

  var callback = this.callEvent_.bind(this);
  setTimeout(callback, 75, ['AdStopped']);
};

VpaidVideoPlayer.prototype.setAdVolume = function (value) {
  this.attributes_['volume'] = value;
  if (value > 0) {
    this.videoSlot_.muted = false;
  } else {
    this.videoSlot_.muted = true;
  }
  this.videoSlot_.volume = this.attributes_['volume'];

  this.callEvent_('AdVolumeChange');
};

VpaidVideoPlayer.prototype.getAdVolume = function () {
  this.log('getAdVolume');
  return this.attributes_['volume'];
};

VpaidVideoPlayer.prototype.resizeAd = function (width, height, viewMode) {
  this.log('resizeAd ' + width + 'x' + height + ' ' + viewMode);
  this.attributes_['width'] = width;
  this.attributes_['height'] = height;
  this.attributes_['viewMode'] = viewMode;
  this.updateVideoPlayerSize_();
  this.callEvent_('AdSizeChange');
};

VpaidVideoPlayer.prototype.pauseAd = function () {
  this.log('pauseAd');
  this.videoSlot_.pause();
  this.callEvent_('AdPaused');
};

VpaidVideoPlayer.prototype.resumeAd = function () {
  this.log('resumeAd');
  this.videoSlot_.play();
  this.callEvent_('AdPlaying');
};

VpaidVideoPlayer.prototype.expandAd = function () {
  this.log('expandAd');
  this.attributes_['expanded'] = true;
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  }
  this.callEvent_('AdExpanded');
};

VpaidVideoPlayer.prototype.getAdExpanded = function () {
  this.log('getAdExpanded');
  return this.attributes_['expanded'];
};

VpaidVideoPlayer.prototype.getAdSkippableState = function () {
  this.log('getAdSkippableState');
  return this.attributes_['skippableState'];
};

VpaidVideoPlayer.prototype.collapseAd = function () {
  this.log('collapseAd');
  this.attributes_['expanded'] = false;
};

VpaidVideoPlayer.prototype.skipAd = function () {
  this.log('skipAd');
  var skippableState = this.attributes_['skippableState'];
  if (skippableState) {
    this.callEvent_('AdSkipped');
  }
};

VpaidVideoPlayer.prototype.subscribe = function (
  aCallback,
  eventName,
  aContext) {
  this.log('Subscribe ' + aCallback);
  var callBack = aCallback.bind(aContext);
  this.eventsCallbacks_[eventName] = callBack;
};

VpaidVideoPlayer.prototype.unsubscribe = function (eventName) {
  this.log('unsubscribe ' + eventName);
  this.eventsCallbacks_[eventName] = null;
};

VpaidVideoPlayer.prototype.getAdWidth = function () {
  return this.attributes_['width'];
};

VpaidVideoPlayer.prototype.getAdHeight = function () {
  return this.attributes_['height'];
};

VpaidVideoPlayer.prototype.getAdRemainingTime = function () {
  return this.attributes_['remainingTime'];
};

VpaidVideoPlayer.prototype.getAdDuration = function () {
  return this.attributes_['duration'];
};

VpaidVideoPlayer.prototype.getAdCompanions = function () {
  return this.attributes_['companions'];
};

VpaidVideoPlayer.prototype.getAdIcons = function () {
  return this.attributes_['icons'];
};

VpaidVideoPlayer.prototype.getAdLinear = function () {
  return this.attributes_['linear'];
};

VpaidVideoPlayer.prototype.log = function (message) {
  if (this.parameters_.debug) {
    console.log(message);
  }
};

VpaidVideoPlayer.prototype.callEvent_ = function (eventType) {
  if (eventType in this.eventsCallbacks_) {
    this.eventsCallbacks_[eventType]();
  }
};

const getVPAIDAd = function () {
  return new VpaidVideoPlayer();
};

export default getVPAIDAd;